import { useState } from "react";
import { toast } from "react-toastify";
import MenuService from "../../../rest/menuService";

export function useMenuSelection(pagedData, itemType) {
    const [selectedItems, setSelectedItems] = useState([]);

    const getItemId = (item) => {
        if (!item) return null;
        if (itemType === 'Receita') return item.recipe_id;
        if (itemType === 'Combo') return item.combo_id;
        return item.id;
    };

    const handleSelectAll = (e) => {
        if (itemType === 'Produto') return;
        
        if (e.target.checked && pagedData) {
            setSelectedItems(pagedData.map(item => getItemId(item)).filter(id => id !== null));
        } else {
            setSelectedItems([]);
        }
    };

    const handleSelectItem = (id) => {
        setSelectedItems(prev => 
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const clearSelection = () => setSelectedItems([]);

    const batchStatusUpdate = async (isActive) => {
        try {
            const typeKey = itemType === 'Receita' ? 'recipe' : 'combo';
            
            const payload = {
                ids: selectedItems,
                active: isActive
            };

            await MenuService.batchStatusUpdate(payload, typeKey);
            
            toast.success(`Status atualizado com sucesso!`);
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar status.");
        }
    };

    return {
        selectedItems,
        handleSelectAll,
        handleSelectItem,
        clearSelection,
        getItemId,
        actions: { batchStatusUpdate }
    };
}